import React from 'react';
import {connect} from 'react-redux';
import {dispatch} from 'redux';
import {Types} from 'api/resources';
import {pageCount} from "utils/DBUtils";

import PagingBar from 'components/common/PagingBar';
import {requestStoreOrdersAction} from '../actions';

const mapStateToProps = (state) => {
    const { page, total, count, object } = state.rewards.storeOrders;
    return {
        currentPage: page,
        count: pageCount(total, count),
        maxPages: 10,
        total: total,
        numOfItemsOnPage: 25
    }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onPageSelected: (page) => dispatch(requestStoreOrdersAction(ownProps.retailerItemId, ownProps.year, ownProps.month, ownProps.numPerPage, page)),
    onNextClicked: (currentPage) => dispatch(requestStoreOrdersAction(ownProps.retailerItemId, ownProps.year, ownProps.month, ownProps.numPerPage, currentPage+1)),
    onPreviousClicked: (currentPage) => dispatch(requestStoreOrdersAction(ownProps.retailerItemId, ownProps.year, ownProps.month, ownProps.numPerPage, currentPage-1))
});

const PurchaseInfoPagingBar = connect(mapStateToProps, mapDispatchToProps)(PagingBar);

export default PurchaseInfoPagingBar;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/PurchaseInfoPagingBar.jsx